import AboutApartmentRuleItem from './AboutApartmentRuleItem';
import Vue, { CreateElement, VNode, VNodeData, VNodeChildren } from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SimpleDescription } from '@/components';
import { MappedApartmentRules } from '@/types';
import './style.styl';

@Component({
  name: 'AboutApartmentRule',
})
export default class AboutApartmentRule extends Vue {
  @Prop({ type: String, default: ''}) public readonly houseRule!: string;
  @Prop({ type: String, default: ''}) public readonly houseRulesDescription!: string;
  @Prop({ type: String, default: ''}) public readonly apartmentRule!: string;
  @Prop({ type: Boolean, default: false}) public readonly isMobile!: boolean;
  @Prop({ type: Array, default: () => []}) public readonly mappedApartmentRules!: MappedApartmentRules;

  private state: MappedApartmentRules | null = null;

  @Watch('mappedApartmentRules', { immediate: true, deep: true })
  private updateDate(value: MappedApartmentRules) {
    this.state = value;
  }

  private render(createElement: CreateElement): VNode {

    const descriptionHouse: VNode = createElement(SimpleDescription, {
      props: {
        subTitle: this.houseRule,
        description: this.houseRulesDescription,
      },
    } as VNodeData);

    const rules: Array<(boolean | VNode)> | boolean = !!this.state && this.state.map((item) => {
      if (item.value !== null) {
        return createElement(AboutApartmentRuleItem, {
          props: {
            name: item.name,
            value: item.value,
          },
        } as VNodeData);
      } else {
        return false;
      }
    });

    const descriptionApartment: VNode = createElement(SimpleDescription, {
      props: {
        subTitle: this.apartmentRule,
      },
    } as VNodeData, rules as VNodeChildren);

    return createElement('div',
      {
        class: ['apartment-rules', 'flex-between', this.isMobile && 'mobile'],
      },
      [
        // descriptionHouse,
        descriptionApartment,
      ],
    ) as VNode;
  }
}
